import React from "react";

const Download = props => (
  <svg viewBox="0 0 24 24" width="1em" height="1em" {...props}>
    <g
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke="currentColor"
    >
      <path d="M12 1v16M18 11l-6 6-6-6M22 22H2" />
    </g>
  </svg>
);

export default Download;



// WEBPACK FOOTER //
// ./src/theme/icons/Download.js